<template>
  <div style="margin-top: 86px">
    <div class="products-top">
      <div style="margin: 0px 100px;position: relative">
        <el-image
          style="height: 500px;width: 600px;position: absolute"
          :src="require('../../assets/image/products/products_1.jpg')"
          fit="contain"></el-image>
        <div class="products-top-cover">
          <div class="products-top-title">
            Advanced Medical Devices and Integrated Solutions
          </div>
          <div class="products-top-content">We are providing animal medical solutions including medical imaging system, rapid tests, patient monitors, surgical equipment and cages.
            Innovation, quality and service are our core values.
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 30px; margin-bottom: 30px;">
      <div>
        <div class="category-box" v-for="item in productCategorys" :key="item.productCategoryId">
          <div class="grid">
            <div class="grid-cell"><img class="img" :src="item.imgUrl" /></div>
            <hr class="vr">
            <div class="detail grid-cell">
              <router-link :to="{path:item.productCategoryRouter, query:{productCategoryId:item.productCategoryId}}">
                <div class="detailTitle">{{item.productCategoryTitle}}</div>
              </router-link>
              <div class="detailInfo">{{item.productCategoryContent}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'Products',
  data() {
    return {
      productCategorys: []
    }
  },
  methods: {
    initCategorys() {
      let url = '/product/listCategory';
      this.getRequest(url).then(resp => {
        if (resp) {
          this.productCategorys = resp.data;
          if(this.productCategorys && this.productCategorys.length > 0){
            var _this = this;
            this.productCategorys.forEach(row => {
              var imgUrl = _this.baseUrl + '/pic/viewPic?picId=' + row.productCategoryPicId;
              row.imgUrl = imgUrl;
            })
          }
        }
      });
    }
  },
  mounted() {
    this.initCategorys();
  },
}
</script>

<style src="../../assets/css/products.css" scoped>


</style>
